export const videoEmbedUrl = 'https://www.youtube.com/embed/SDDR-0ssKxA';
